function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M54.0675 30.9258V58.2513C54.0675 59.135 53.3511 59.8513 52.4675 59.8513H9.38662C8.50296 59.8513 7.78662 59.135 7.78662 58.2513V30.9258",
  strokeWidth: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M58.2511 16.4615H3.6C2.71634 16.4615 2 17.1779 2 18.0615V29.3243C2 30.208 2.71634 30.9243 3.6 30.9243H58.2511C59.1347 30.9243 59.8511 30.208 59.8511 29.3243V18.0615C59.8511 17.1779 59.1347 16.4615 58.2511 16.4615Z",
  strokeWidth: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M30.9263 59.8498V16.4615",
  strokeWidth: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M30.4323 14.5797C30.7244 15.5462 29.9838 16.4628 28.9742 16.4628H17.9094C15.9915 16.4628 14.1521 15.7009 12.796 14.3447C11.4399 12.9886 10.678 11.1493 10.678 9.23138C10.678 7.3135 11.4399 5.47417 12.796 4.11802C14.1521 2.76188 15.9915 2 17.9094 2C25.7447 2 29.2486 10.6631 30.4323 14.5797Z",
  strokeWidth: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M31.4198 14.5797C31.1277 15.5462 31.8683 16.4628 32.878 16.4628H43.9428C45.8606 16.4628 47.7 15.7009 49.0561 14.3447C50.4123 12.9886 51.1741 11.1493 51.1741 9.23138C51.1741 7.3135 50.4123 5.47417 49.0561 4.11802C47.7 2.76188 45.8606 2 43.9428 2C36.1074 2 32.6036 10.6631 31.4198 14.5797Z",
  strokeWidth: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgGift(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGift);
export default __webpack_public_path__ + "static/media/gift.883f0bf0.svg";
export { ForwardRef as ReactComponent };